var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZip = function SvgZip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Zip_svg__\\u56FE\\u5C42_1",
    x: 0,
    y: 0,
    viewBox: "0 0 64 40"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".Zip_svg__st3{fill:#1a0826}")), /*#__PURE__*/React.createElement("path", {
    d: "M3.2 39.5c-1.5 0-2.7-1.3-2.7-2.8V3.3C.5 1.7 1.7.5 3.2.5h57.6c1.5 0 2.7 1.3 2.7 2.8v33.3c0 1.6-1.2 2.8-2.7 2.8H3.2z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8 1C62 1 63 2 63 3.3v33.3c0 1.3-1 2.3-2.2 2.3H3.2C2 39 1 38 1 36.7V3.3C1 2 2 1 3.2 1zm0-1H3.2C1.4 0 0 1.5 0 3.3v33.3C0 38.5 1.4 40 3.2 40h57.6c1.8 0 3.2-1.5 3.2-3.3V3.3C64 1.5 62.6 0 60.8 0",
    style: {
      fill: "#ddd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.5 14.2 1.7 13.7h16.3l-1.7-13.7z",
    style: {
      fill: "#aa8fff"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2 9c1 1 1.2 2.5.3 3.5-.8 1-2.3.8-3.5-.2-1-1-1.2-2.5-.3-3.5.8-.8 2.5-.8 3.5.2",
    className: "Zip_svg__st3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M58.7 19c-.3-3-2.8-4.8-6-4.8H41.8l1.7 13.7h4.8l-.3-2.7h5.2c4-.2 6-2.7 5.5-6.2m-6 2.2h-5.2l-.3-3.3h5.2c1.2 0 1.8.7 2 1.7-.1.6-.4 1.6-1.7 1.6",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#1a0826"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m6.5 24 .5 3.8h16.3l-.5-4.3h-7.7V23l6.8-5-.5-3.8H5.3l.5 4.3h7.7v.5z",
    className: "Zip_svg__st3"
  })));
};
export default SvgZip;